import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

const modules = [CommonModule, HttpClientModule, FormsModule, RouterModule, ReactiveFormsModule];

@NgModule({
  imports: modules,
  exports: modules,
})
export class AngularBaseModule {}
